import { ToggleGroup, ToggleGroupItem } from "@/modern/components/ui/toggle-group";
import { Grid3x3, List } from "lucide-react";
import { useMyMediaContext } from "../context/MyMediaContext";

export const ViewToggle = () => {
  const { viewMode, setViewMode } = useMyMediaContext();

  return (
    <ToggleGroup
      type="single"
      value={viewMode}
      onValueChange={(value) => {
        if (value) setViewMode(value as "grid" | "list");
      }}
      variant="outline"
      size="sm"
      className="h-8"
    >
      <ToggleGroupItem value="grid" aria-label="Grid view" className="px-3 h-8">
        <Grid3x3 className="h-4 w-4" />
        Grid
      </ToggleGroupItem>
      <ToggleGroupItem value="list" aria-label="List view" className="px-3 h-8">
        <List className="h-4 w-4" />
        List
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
